import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=7f1a036a"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"
import style0 from "./inicio.vue?vue&type=style&index=0&id=7f1a036a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports